import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useQuery } from '@apollo/client';
import { EmptyTag } from '@quikr/ui';
import { GlobalStyle } from '@quikr/ui/theme';
import Quikr from '@quikr/ui/theme/Quikr';
import Routes from '../../routes';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import { common } from '../../gql/common';
import { AppProvider } from '../../context';
import { AnalyticsProvider } from '../../context/ga';
import { AnalyticsConfig } from '../../constants/analytics';

const App = () => {
  const { data: { isShell, isMobile, source, isWebview } = {}, loading } = useQuery(common);
  // eslint-disable-next-line
  if (loading) return null;
  return (
    <AppProvider>
      <AnalyticsProvider config={AnalyticsConfig(isMobile, source)}>
        <EmptyTag />
        <ThemeProvider theme={Quikr}>
          <GlobalStyle />
          {isShell && !isWebview && <Header host="Quikr" />}
          <Routes />
          {isShell && !isWebview && <Footer host="Quikr" />}
        </ThemeProvider>
      </AnalyticsProvider>
    </AppProvider>
  );
};
export default App;
